import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DatePipe, NgClass, NgForOf } from "@angular/common";
import { Subject, takeUntil } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from "@ngneat/transloco";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { TicketService } from '../../../../services/ticket.service';
import { TicketInterface } from "../../../../interfaces/ticket-interface";
import { MessageInterface } from "../../../../interfaces/message-interface";

@Component({
    selector   : 'app-ticket-list',
    templateUrl: './ticket-list.component.html',
    styleUrls : ['./ticket-list.component.scss'],
    standalone: true,
    imports   : [
        TranslocoPipe,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        NgForOf,
        DatePipe,
        MatButtonModule,
        NgClass
    ],
})

export class TicketListComponent implements OnInit, OnDestroy {
    @Input() activeTicket: TicketInterface | null = null;
    @Output() activeTicketChange = new EventEmitter<TicketInterface>();
    
    tickets: TicketInterface[] = [];
    filteredTickets: TicketInterface[] = [];
    stateFormControl: FormControl = new FormControl('all');
    
    private unsubscribeAll: Subject<any> = new Subject<any>();
    
    constructor(
        private ticketService: TicketService,
    ) {
    }
    
    ngOnInit(): void {
        this.ticketService
            .list()
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe({
                next : (tickets: TicketInterface[]) => {
                    this.tickets = tickets;
                    this.filteredTickets = tickets;
                },
                error: (err) => {
                    console.error('Error fetching tickets:', err);
                }
            });
        
        this.stateFormControl.valueChanges.pipe(
            takeUntil(this.unsubscribeAll)
        ).subscribe((selectedState: string) => {
            this.filterTickets(selectedState);
        });
    }
    
    filterTickets(selectedState: string): void {
        let tempTickets: TicketInterface[];
        if (selectedState === 'all') {
            tempTickets = [...this.tickets];
        } else {
            tempTickets = this.tickets.filter(ticket => ticket.status === selectedState);
        }
        // Si activeTicket existe y es el ticket de creación (por ejemplo, con id "new-ticket"), lo añadimos al inicio.
        if (this.activeTicket && this.activeTicket.id === 'new-ticket') {
            // Prevenir duplicados si ya existe en la lista
            const exists = tempTickets.find(ticket => ticket.id === 'new-ticket');
            if (!exists) {
                tempTickets = [this.activeTicket, ...tempTickets];
            }
        }
        this.filteredTickets = tempTickets;
    }
    
    /*
    showUnreadTickets(): void {
        // Filtra los tickets donde ticket.read es false
        this.filteredTickets = this.tickets.filter(ticket => !ticket.read);
    }
    */
    
    startNewTicketConversation(): void {
        const initialMessage: MessageInterface = {
            id        : 'new-message',
            ticket_id : 'new-ticket',
            user_id   : 'customer-support',
            user_role : 'super-admin',
            content   : `Hello, Claudia! We're here to help. We'll ask you a few questions and then connect you with one of our team members.
                        What issue can we assist you with? Please provide a title.`,
            created_at: new Date()
        };
        
        const newTicket: TicketInterface = {
            id         : 'new-ticket',
            title      : 'Customer Support from GEOactive',
            description: '',
            status     : 'new_ticket',
            created_at : new Date(),
            user_id    : '',
            read       : true,
            messages   : [initialMessage]
        };
        
        this.activeTicketChange.emit(newTicket);
        
        // Insert the new ticket into the list if it doesn't exist yet,
        // then reapply the filter for the displayed tickets.
        if (!this.tickets.find(ticket => ticket.id === 'new-ticket')) {
            this.tickets = [newTicket, ...this.tickets];
            this.filterTickets(this.stateFormControl.value);
        }
    }
    
    
    // Función que se llama al hacer click en un ticket
    selectTicket(ticket: TicketInterface): void {
        /*
        // Marca el ticket como leído si aún no lo está
        if (!ticket.read) {
            ticket.read = true;
            // Opcional: llama al servicio para actualizar el estado en el backend
            // this.ticketService.markAsRead(ticket.id).subscribe();
        }
        */
        this.ticketService.show(ticket.id).subscribe({
            next: (ticketDetail: TicketInterface) => {
                this.activeTicketChange.emit(ticketDetail);
                
            }
        })
    }
    
    ngOnDestroy(): void {
        this.unsubscribeAll.next(null);
        this.unsubscribeAll.complete();
    }
}
